import { useToken } from './useToken'

export type Role = 'guest' | 'user'

export function useRole(): Role {
  const { token } = useToken()
  if (!token) return 'guest'
  return 'user'
}
